import React from 'react';
import { SvgIcon } from '../../../common/SvgIcon';
import { simpleIconPropsTypes } from '../../propTypes';

export const IconMarketResearch = (props) => {
  const { width = 22, height = 22 } = props;

  return (
    <SvgIcon width={width} height={height} viewBox="0 0 24 24">
      {/* 1. The Handle (Angled Rect) */}
      <path fill="currentColor" d="M15.5 16.5 L 19.5 20.5 A 1.5 1.5 0 0 0 21.5 18.5 L 17.5 14.5 Z" />

      {/* 2. The Glass Ring (Compound Path: Outer Circle + Inner Hole) 
          Outer Radius: 9 | Inner Radius: 7 (Thinner rim, more space)
      */}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 1 A9 9 0 1 0 10 19 A9 9 0 1 0 10 1 Z M10 17 A7 7 0 1 1 10 3 A7 7 0 1 1 10 17 Z"
      />

      {/* 3. The Bars (Data) - Centered in the new larger opening */}
      <g fill="currentColor">
        {/* Left Bar */}
        <rect x="7" y="10" width="1.5" height="3" rx="0.75" />
        {/* Middle Bar */}
        <rect x="9.25" y="8" width="1.5" height="5" rx="0.75" />
        {/* Right Bar */}
        <rect x="11.5" y="6" width="1.5" height="7" rx="0.75" />
      </g>
    </SvgIcon>
  );
};

IconMarketResearch.propTypes = simpleIconPropsTypes;
